<template>
  <el-dialog title="输入密码"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             modal-append-to-body
             append-to-body
             width="500px"
             :visible.sync="box">
    <el-form :model="form">
      <el-form-item label="账号">
        <el-input :disabled="disabled" v-model="account"
                  type="text"
                  placeholder="请输入账号">
        </el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input :disabled="disabled" v-model="password"
                  type="password"
                  placeholder="请输入密码">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary"
                 :loading="disabled"
                 @click="handleLogin">确 定
      </el-button>
    </div>
  </el-dialog>
</template>


<script>
  import { mapState } from 'vuex';
export default {
  data () {
    return {
      disabled: false,
      flag: false,
      account: '',
      password: '',
      form: {},
      box: false,
    }
  },
  created () {
    this.password = this.pwd;
    if (this.validatenull(this.password)) {
      this.handleLogin();
    } else {
      this.flag = true;
      this.$emit('submit');
    }
  },
  computed: {
    ...mapState(['pwd']),
  },
  methods: {
    handleLogin () {
      this.disabled = true;
      if (this.website.LOGIN.ACCOUNT === this.account && this.website.LOGIN.PWD === this.password) {
        this.disabled = false;
        this.$store.commit('setPwd', this.password);
        this.box = false;
        this.flag = true;
        this.$emit('submit');
      } else {
        this.$message.error('密码错误！');
        this.disabled = false;
        this.box = true;
        this.flag = false;
      }
    },
  }
}
</script>

<style>
</style>
